module.exports = __webpack_public_path__ + "img/bg-ico-hero.b5c826fc.jpg";